import {createStore} from "vuex"
import buyer from './modules/buyerChat'
//创建store实例
const store=createStore({
    modules: {
      buyer
    },
    state(){
        return {
            userInfoB2B:{},
            paymentAmount:'',
            b2bWebInfo:{},
            locale:"zh",
            carGoodsNums:0
        }
    },
    mutations:{
        setUserInfoB2B: (state, data) => {
          console.log(data)
            state.userInfoB2B = data
        },
        setPaymentAmount: (state, data) => {
          console.log(data)
            state.paymentAmount = data
        },
        setb2bWebInfo: (state, data) => {
          console.log(data)
          state.b2bWebInfo = data
        },
        localeB2B: (state, data) => {
          state.locale = data
        },
    }
})
export default store;